import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { clientAPI } from "../api/client";
import { NumberOfPerPage } from "../utils/globalVariable";
import {
  formatDateToLocal,
  customDateFormat,
  formatTime,
} from "../utils/utils";

const NUMBER_NFT_PER_PAGE = NumberOfPerPage.attendance;
// const queryKey = "attendance";

async function fetchAttendance(
  currentPage,
  saleBlock,
  saleArea,
  department,
  supportDepartmentId,
  branchId,
  businessCategoryIds,
  search,
  date,
  status,
) {
  try {
    const options = {
      limit: NUMBER_NFT_PER_PAGE,
      page: currentPage,
    };

    if (search !== undefined) options.search = search;
    if (saleBlock) options.saleBlockId = saleBlock;
    if (saleArea) options.saleAreaId = saleArea;
    if (department) options.department = department;
    if (supportDepartmentId) options.supportDepartmentId = supportDepartmentId;
    if (branchId) options.branchId = branchId;
    if (businessCategoryIds && businessCategoryIds.length > 0)
      options.businessCategoryIds = businessCategoryIds.join(",");
    if (status !== null && status !== undefined && status !== "")
      options.status = status;

    if (date) {
      const dateNumber = new Date(date);
      const month = dateNumber.getMonth() + 1;
      const year = dateNumber.getFullYear();
      options.date = year + "-" + month;
    }

    const queryParams = new URLSearchParams(options).toString();
    let data = await clientAPI("get", `/attendance/?${queryParams}`);
    // console.log(data);
    const totalPages = Math.ceil(data?.pagination?.total / NUMBER_NFT_PER_PAGE);
    const entries = data?.pagination?.total;
    const startEntry =
      (data?.pagination?.page - 1) * data?.pagination?.limit + 1;
    const endEntry = Math.min(
      data?.pagination?.page * data?.pagination?.limit,
      entries,
    );

    const newData = data?.items.map((item, index) => {
      return {
        date: (item?.month || "-") + "/" + (item?.year || "-"),
        year: item?.year || "",
        month: item?.month || "",
        codeEmployee: item?.employeeObject?.code || "-",
        idEmployee: item?.employeeObject?._id || "-",
        fullName: item?.employeeObject?.fullName || "-",
        saleBlock: item?.saleBlock?.name || "-",
        saleArea: item?.saleArea?.name || "-",
        supportDepartment: item?.supportDepartment?.name || "-",
        jobPosition: item?.jobPosition?.name || "-",
        commissionRate: item?.commissionRate || "-",
        workingDays: item?.workingDays || "0",
        businessCategory: `${item?.businessCategory?.name || "-"} ${item?.isElite ? "(Elite)" : ""}`,
        department: item?.employeeObject?.department || 0,
        identificationNumber: item?.employee?.identificationNumber || "-",
        bankInfo: [item?.employee?.bankAccount, item?.employee?.bankName],
        totalStandardWorking: item?.totalStandardWorking || "0",
        referralCode: item?.employee?.referralEmployee?.code || "-",
        referralName: item?.employee?.referralEmployee?.fullName || "-",
        referralBlock: item?.employee?.referralEmployee?.saleBlock?.name || "-",
        referralArea: item?.employee?.referralEmployee?.saleArea?.name || "-",
        saleAreaManager: item?.saleAreaManager?.fullName || "-",
        saleBlockManager: item?.saleBlockManager?.fullName || "-",
        supportDepartmentManager:
          item?.supportDepartmentManager?.fullName || "-",
        // Chốt công: đã chốt / BGĐ đang mở chỉnh sửa (lưu xong tự khoá lại)
        lockStatus: item?.isLocked
          ? "Đã chốt"
          : item?.lockedAt
            ? "Đang mở chỉnh sửa"
            : "-",
        isLocked: item?.isLocked || false,
        dataEdit: {
          id: item?._id || "",
          businessCategoryId: item?.businessCategory?._id || "",
          jobPositionId: item?.jobPosition?._id || "",
          saleAreaId: item?.saleArea?._id || "",
          commissionRate: item?.commissionRate || "",
          saleBlockId: item?.saleBlock?._id || "",
          workingDays: item?.workingDays || "0",
          totalStandardWorking: item?.totalStandardWorking || "0",
          department: item?.employeeObject?.department || 0,
          supportDepartmentId: item?.supportDepartment?._id || "",
          supportDepartmentManagerId: item?.supportDepartmentManagerId || "",
          saleAreaManagerId: item?.saleAreaManagerId || "",
          saleBlockManagerId: item?.saleBlockManagerId || "",
          isElite: item?.isElite || false,
        },
        export: {
          date: item?.month && item?.year ? item?.month + "/" + item?.year : "",
          codeEmployee: item?.employeeObject?.code || "",
          fullName: item?.employeeObject?.fullName || "",
          saleBlock: item?.saleBlock?.name || "",
          saleArea: item?.saleArea?.name || "",
          jobPosition: item?.jobPosition?.name || "",
          commissionRate: item?.commissionRate || "",
          workingDays: item?.workingDays || "",
          businessCategory: item?.businessCategory?.name || "",
        },
      };
    });

    return { data: newData, totalPages, entries, startEntry, endEntry };
  } catch (error) {
    console.error("Error fetching attendance data:", error);
    return { data: [], totalPages: 0 };
  }
}

async function fetchListAttendanceByEmployeeAndMonth(
  currentPage,
  employeeId,
  month,
  year,
  page,
  limit,
  sort,
) {
  try {
    const options = {
      limit: NUMBER_NFT_PER_PAGE,
      page: currentPage,
    };

    if (employeeId !== undefined) options.employeeId = employeeId;
    if (month) options.month = month;
    if (year) options.year = year;
    if (page) options.page = page;
    if (limit) options.limit = limit;
    if (sort) options.sort = sort;

    const queryParams = new URLSearchParams(options).toString();
    let data = await clientAPI(
      "get",
      `/attendance/listAttendanceByEmployeeAndMonth?${queryParams}`,
    );

    if (employeeId) {
      data = data?.items[0];
    }

    return { data };
  } catch (error) {
    console.error("Error fetching attendance data:", error);
    return { data: [], totalPages: 0 };
  }
}

// Phân loại ngày công (AttendanceSummary.attendanceType)
const ATTENDANCE_TYPE_LABEL = {
  CHECKIN_ON_TIME: "Chấm công đúng giờ",
  CHECKIN_LATE: "Chấm công muộn",
  HALF_SHIFT: "Chấm công nửa ca",
  REGISTER_OUTSIDE: "Chấm công ngoài",
  MAKEUP_WORK: "Làm bù",
  LEAVE: "Nghỉ phép",
  HOLIDAY: "Ngày nghỉ",
  ABSENT: "Vắng",
};

async function fetchGetCheckinEmployeeByMonth(employeeId, date) {
  try {
    const options = {};

    if (employeeId) options.employeeId = employeeId;
    if (date) options.date = date;

    const queryParams = new URLSearchParams(options).toString();
    let data = [];

    if (queryParams) {
      // API web (không dùng API app /employee/app/getCheckinEmployeeByMonth vì
      // API đó chỉ cho cấp trên xem cấp dưới, HCNS bị trả 403)
      data = await clientAPI("get", `/attendance/daily-by-month?${queryParams}`);
    }

    // Dữ liệu từ AttendanceSummary: date (ngày), attendanceType (phân loại)
    const newData = Array.isArray(data)
      ? data.map((item, index) => {
          return {
            time: item?.date ? customDateFormat(item?.date) : "-",
            checkinTime: item?.checkinTime
              ? formatTime(item?.checkinTime)
              : "-",
            type: ATTENDANCE_TYPE_LABEL[item?.attendanceType] || "-",
            workingDayRate: item?.workingDayRate ?? "-",
          };
        })
      : [];

    return { data: newData };
  } catch (error) {
    console.error("Error fetching attendance data:", error);
    return { data: [], totalPages: 0 };
  }
}

export function useAttendance(
  saleBlock,
  saleArea,
  department,
  supportDepartmentId,
  branchId,
  businessCategoryIds,
  search,
  date,
  status,
) {
  const [currentPage, setCurrentPage] = useState(1);
  const executionDate = date ? formatDateToLocal(date) : "";
  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [
      currentPage,
      saleBlock,
      saleArea,
      department,
      supportDepartmentId,
      branchId,
      businessCategoryIds,
      search,
      date,
      status,
    ],
    queryFn: () =>
      fetchAttendance(
        currentPage,
        saleBlock,
        saleArea,
        department,
        supportDepartmentId,
        branchId,
        businessCategoryIds,
        search,
        executionDate,
        status,
      ),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error("Error fetching attendance data:", error);
    },
  });

  const nextPage = () => {
    if (currentPage < data?.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return {
    attendanceData: data?.data,
    totalPages: data?.totalPages,
    refetch,
    isLoading,
    isRefetching,
    prevPage,
    nextPage,
    setCurrentPage,
    currentPage,
    entries: data?.entries,
    startEntry: data?.startEntry,
    endEntry: data?.endEntry,
  };
}

export function useListAttendanceByEmployeeAndMonth(
  employeeId,
  month,
  year,
  page,
  limit,
  sort,
) {
  const [currentPage, setCurrentPage] = useState(1);
  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [employeeId, month, year, page, limit, sort],
    queryFn: () =>
      fetchListAttendanceByEmployeeAndMonth(
        currentPage,
        employeeId,
        month,
        year,
        page,
        limit,
        sort,
      ),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error(
        "Error fetching attendance by employee and month data:",
        error,
      );
    },
  });

  const nextPage = () => {
    if (currentPage < data?.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return {
    getByEmployeeAndMonthData: data?.data,
    totalPages: data?.totalPages,
    refetch,
    isLoading,
    isRefetching,
    prevPage,
    nextPage,
    setCurrentPage,
    currentPage,
    entries: data?.entries,
    startEntry: data?.startEntry,
    endEntry: data?.endEntry,
  };
}

export function useGetCheckinEmployeeByMonth(employeeId, date) {
  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [employeeId, date],
    queryFn: () => fetchGetCheckinEmployeeByMonth(employeeId, date),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error(
        "Error fetching attendance by employee and month data:",
        error,
      );
    },
  });
  return {
    getCheckinEmployeeByMonth: data?.data,
    totalPages: data?.totalPages,
    refetch,
    isLoading,
    isRefetching,
    entries: data?.entries,
    startEntry: data?.startEntry,
    endEntry: data?.endEntry,
  };
}
